var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.608.9l5.39 5.386.004 7.62-5.386 5.39-7.62.004-5.391-5.386-.003-7.62L7.988.904 15.608.9z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.608 1.4l5.39 5.386.004 7.62-5.386 5.39-7.62.004-5.391-5.386-.003-7.62 5.386-5.39 7.62-.004z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.5a1.1 1.1 0 112.2 0v5a1.1 1.1 0 11-2.2 0v-5zM9 15.1a.9.9 0 01.9-.9h.4a.9.9 0 010 1.8h-.4a.9.9 0 01-.9-.9z",
    fill: "#DD3636"
  })));
}

export default "data:image/svg+xml,%3Csvg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath opacity='0.25' d='M15.6078 0.899902L20.9984 6.28593L21.0016 13.9061L15.6155 19.2967L7.99533 19.2999L2.60477 13.9139L2.60156 6.29367L7.98759 0.903105L15.6078 0.899902Z' fill='%231D1D1D'/%3E %3Cpath d='M13.6078 1.3999L18.9984 6.78593L19.0016 14.4061L13.6155 19.7967L5.99533 19.7999L0.604766 14.4139L0.601562 6.79367L5.98759 1.40311L13.6078 1.3999Z' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 6.50075C9 5.89277 9.49249 5.3999 10.1 5.3999C10.7075 5.3999 11.2 5.89277 11.2 6.50075V11.4991C11.2 12.107 10.7075 12.5999 10.1 12.5999C9.49249 12.5999 9 12.107 9 11.4991V6.50075Z' fill='%23DD3636'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 15.1C9 14.6029 9.40264 14.2 9.89931 14.2H10.3007C10.7974 14.2 11.2 14.6029 11.2 15.1C11.2 15.597 10.7974 16 10.3007 16H9.89931C9.40264 16 9 15.597 9 15.1Z' fill='%23DD3636'/%3E %3C/svg%3E";
export { SvgWarning as ReactComponent };